import Main from "./Components/Main/Main";
import {ToastContainer} from "react-toastify"

function App() {
  return (
    <div>
        <Main />
        <ToastContainer />
    </div>
  );
}

export default App;
